<div class="filter filter-padded filter-double-padded-right">
  <span class="filter-body">
    <div class="filter-title" style="width: 90px">
      <span class="filter-title-text">Types</span>
      <div class="filter-tip">
        <p>
          Enter a space-separated list of values enclosed in "Double Quotes" to use as BaseType.
          <br /><br /><strong>Warning!</strong> Use with care. Unrecognized values might cause the filter not to load, or hide too much!
        </p>
      </div>
    </div>
    <span class="sep"></span>
    <input type="text" class="form-control" placeholder="&quot;Base Type One&quot; &quot;Partial Base Type&quot;"
      [disabled]="!rule.displayOptions.active || !rule.baseTypes || !rule.baseTypes.includes('All')" style="display: table; table-layout: fixed; position: unset; float: left; width: 100%; min-width: 250px;"
      [(ngModel)]="rule.advancedConditions!.baseTypes" (change)="updateFilter()">
    <span class="sep"></span>
    <div class="filter-title filter-label" style="width: 65px">
      <span class="filter-title-text">Classes</span>
      <div class="filter-tip" style="text-align: left;">
        <p>
          Enter a space-separated list of values enclosed in "Double Quotes" to use as Class.
          <br /><br /><strong>Warning!</strong> Use with care. Unrecognized values might cause the filter not to load, or hide too much!
        </p>
      </div>
    </div>
    <span class="sep"></span>
    <input type="text" class="form-control" placeholder="&quot;Body Armours&quot; &quot;Mace&quot; &quot;Quarter&quot;"
      [disabled]="!rule.displayOptions.active || rule.itemClass !== 'All'" style="display: table; table-layout: fixed; position: unset; float: left; width: 100%; min-width: 250px;"
      [(ngModel)]="rule.advancedConditions!.classes" (change)="updateFilter()">
    <span class="sep"></span>
    <div class="filter-title filter-label table-checkbox-group">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!rule.displayOptions.hidden"
        (click)="rule.displayOptions.hidden = !rule.displayOptions.hidden; updateFilter();"></button>
      </span>
      <span class="table-checkbox-label">Hidden</span>
    </div>
  </span>
</div>
<div class="filter filter-padded filter-double-padded-right">
  <span class="filter-body">

    <div class="filter-title" style="width: 90px;">
      Item lvl
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
      [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minItemLevel" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    <span class="sep"></span>
    <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
      [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.maxItemLevel" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    <span class="sep"></span>

    <div class="filter-title filter-label">
      Drop lvl
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
      [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minDropLevel" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    <span class="sep"></span>
    <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
      [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.maxDropLevel" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    <span class="sep"></span>

    <div class="filter-title filter-label">
      Area lvl
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
      [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minAreaLevel" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    <span class="sep"></span>
    <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
      [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.maxAreaLevel" (change)="updateFilter()" style="min-width: 40px; width: 40px;">

    @if (poe2 && (rule.itemType === 'All' || rule.itemType === 'All Gear' || rule.itemType === 'All Weapons' || rule.itemType === 'All Armour' || canHaveUnidentifiedTier.includes(rule.itemClass))) {
      <span class="sep"></span>
      <div class="filter-title filter-label">
        Unidentified Tier
      </div>
      <span class="sep"></span>
      <input type="number" placeholder="min" maxlength="1" min="2" max="5" pattern="[2-5]" inputmode="numeric" step="any" class="form-control minmax"
        [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.unidentifiedTier!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
    }

    <span class="sep"></span>
    <div class="filter-title filter-label">
      Stack Size
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="5" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
      [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minStackSize!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
  </span>
</div>
@if (!cantHaveQuality.includes(rule.itemClass) || canBeIdentified.includes(rule.itemClass)) {
  <div class="filter filter-padded filter-double-padded-right">
    <span class="filter-body">
      @if (!cantHaveQuality.includes(rule.itemClass)) {
        <div class="filter-title" style="width: 90px">
          Quality
        </div>
        <span class="sep"></span>
        <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
          [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minQuality!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
        <span class="sep"></span>
      }
      <div class="filter-title {{ !cantHaveQuality.includes(rule.itemClass) ? 'filter-label' : '' }}" style="width: 90px">
        Corrupted
      </div>
      <span class="sep"></span>
      <app-select [(ngModel)]="rule.advancedConditions!.corrupted" (selectedValueChange)="updateFilter()" [disabled]="!rule.displayOptions.active" style="width: 65px;">
        <app-option [value]="undefined" [text]="'Any'"></app-option>
        <app-option [value]="YesNoAny.Yes" [text]="'Yes'"></app-option>
        <app-option [value]="YesNoAny.No" [text]="'No'"></app-option>
      </app-select>
      <span class="sep"></span>
      <div class="filter-title filter-label" style="width: 90px">
        Identified
      </div>
      <span class="sep"></span>
      <app-select [(ngModel)]="rule.advancedConditions!.identified" (selectedValueChange)="updateFilter()" [disabled]="!rule.displayOptions.active" style="width: 65px;">
        <app-option [value]="undefined" [text]="'Any'"></app-option>
        <app-option [value]="YesNoAny.Yes" [text]="'Yes'"></app-option>
        <app-option [value]="YesNoAny.No" [text]="'No'"></app-option>
      </app-select>
      @if (!cantHaveSockets.includes(rule.itemClass)) {
        <span class="sep"></span>
        <div class="filter-title filter-label" style="width: 76px !important;">
          Sockets
        </div>
        <span class="sep"></span>
        <input type="number" placeholder="min" maxlength="1" min="1" max="6" pattern="[1-6]" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!rule.displayOptions.active || !!rule.advancedConditions!.socketGroup || !!rule.advancedConditions!.minLinks"
          [(ngModel)]="rule.advancedConditions!.minSockets!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
        @if (poe1) {
          <span class="sep"></span>
          <div class="filter-title filter-label">
            Links
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="1" min="1" max="6" pattern="[1-6]" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!rule.displayOptions.active || !!rule.advancedConditions!.socketGroup || !!rule.advancedConditions!.minSockets"
           [(ngModel)]="rule.advancedConditions!.minLinks!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
          <span class="sep"></span>
          <div class="filter-title filter-label" style="width: 65px">
            <span class="filter-title-text">Socketgroup</span>
            <div class="filter-tip" style="text-align: left;">
              <p>
                Enter a string of characters representing <strong>linked sockets</strong>. For example, '<strong>RRGX</strong>' would select all gear with at least 4 linked sockets, of which two are <strong>R</strong>ed and one is <strong>G</strong>reen. The <strong>X</strong> can be any colour.
              </p>
            </div>
          </div>
          <span class="sep"></span>
          <input type="text" placeholder="RGBWX" minlength="1" maxlength="6" pattern="[RGBWXT]{1,6}" class="form-control"
            [disabled]="!rule.displayOptions.active || !!rule.advancedConditions!.minLinks || !!rule.advancedConditions!.minSockets"
            [(ngModel)]="rule.advancedConditions!.socketGroup" (keydown)="socketGroupKeyDown($event)" (change)="updateFilter()" style="min-width: 90px; width: 90px;">
          <span class="sep"></span>
          <div class="filter-title filter-label">
            Memory Strands
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="3" min="1" max="10" pattern="[1-10]" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!rule.displayOptions.active"
            [(ngModel)]="rule.advancedConditions!.memoryStrands" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
        }
        <span class="spacer" style="display: table-cell; width: 100%;"></span>
      }
    </span>
  </div>
}
@if (poe1 && (rule.itemType === 'All Gear' || rule.itemType === 'All Weapons' || rule.itemType === 'All Armour' || canHaveInfluence.includes(rule.itemClass))) {
  <div class="filter filter-padded filter-double-padded-right">
    <span class="filter-body">
      <div class="filter-title" style="width: 90px">
        <span class="filter-title-text">Equipment</span>
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.hasInfluence" [disabled]="rule.advancedConditions?.veiled || rule.advancedConditions?.fractured || rule.advancedConditions?.synthesised"
            (click)="rule.advancedConditions!.hasInfluence = !rule.advancedConditions!.hasInfluence; updateFilter();"></button>
        </span>
        <span class="table-checkbox-label">Has Influence</span>
      </div>
      <span class="sep"></span>
      <app-autocomplete style="width: 150px"
        [options]="influences"
        [disabled]="!rule.displayOptions.active || !rule.advancedConditions!.hasInfluence"
        [showOptions]="true"
        [selectedValues]="rule.advancedConditions!.influences || ['All']"
        (selectedValuesChange)="rule.advancedConditions!.influences = $event; updateFilter();"
      ></app-autocomplete>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.veiled" [disabled]="rule.advancedConditions?.hasInfluence || rule.advancedConditions?.fractured || rule.advancedConditions?.synthesised"
            (click)="rule.advancedConditions!.veiled = !rule.advancedConditions!.veiled; updateFilter();"></button>
        </span>
        <span class="table-checkbox-label">Veiled</span>
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.fractured" [disabled]="rule.advancedConditions?.hasInfluence || rule.advancedConditions?.veiled || rule.advancedConditions?.synthesised"
            (click)="rule.advancedConditions!.fractured = !rule.advancedConditions!.fractured; updateFilter();"></button>
        </span>
        <span class="table-checkbox-label">Fractured</span>
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.synthesised" [disabled]="rule.advancedConditions?.hasInfluence || rule.advancedConditions?.veiled || rule.advancedConditions?.fractured"
            (click)="rule.advancedConditions!.synthesised = !rule.advancedConditions!.synthesised; updateFilter();"></button>
        </span>
        <span class="table-checkbox-label">Synthesised</span>
      </div>
      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if (classesWithDefenceTypes.includes(rule.itemClass) || rule.itemType === 'All Armour') {
  <div class="filter filter-padded filter-double-padded-right">
    <span class="filter-body">
      <div class="filter-title" style="width: 90px">
        <span class="filter-title-text">Armour</span>
        <div class="filter-tip">
          <p>
            For each of these defence types, you can specify a minimum value. If you enter '0', however, this means that the gear should not have that kind of defence type.
            <br /><br />For instance, if you enter '15' for Evasion and '0' for Armour, the filter will only show gear that has at least 15 Evasion, and no Armour.
            <br /><br />If, on the other hand, you just enter '15' for Evasion and leave Armour blank, the filter could also show Evasion/Armour and Evasion/Energy Shield-type gear.
          </p>
        </div>
      </div>
      <span class="sep"></span>
      <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
        [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minArmour!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
      <span class="sep"></span>
      <div class="filter-title filter-label" style="width: 76px !important;">
        Evasion
      </div>
      <span class="sep"></span>
      <input type="number" placeholder="min" maxlength="1" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
        [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minEvasion!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
      <span class="sep"></span>
      <div class="filter-title filter-label">
        Energy Shield
      </div>
      <span class="sep"></span>
      <input type="number" placeholder="min" maxlength="5" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
        [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minEnergyShield!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
      @if (poe1) {
        <span class="sep"></span>
        <div class="filter-title filter-label">
          Ward
        </div>
        <span class="sep"></span>
        <input type="number" placeholder="min" maxlength="5" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
          [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minWard!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
        <span class="sep"></span>
        <div class="filter-title filter-label">
          Def. Perc.
        </div>
        <span class="sep"></span>
        <input type="number" placeholder="min" maxlength="3" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
          [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minBaseDefencePercentile!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
      }
    </span>
  </div>
}
@if (rule.itemClass === 'Waystones' || rule.itemClass === 'Maps') {
  <div class="filter filter-padded filter-double-padded-right">
    <span class="filter-body">
      <div class="filter-title" style="width: 90px">
        <span class="filter-title-text">{{ poe2 ? 'Waystone' : 'Map' }}</span>
      </div>
      <span class="sep"></span>
      <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
        [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.waystoneMinTier!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
      <span class="sep"></span>
      <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
        [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.waystoneMaxTier!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.anyEnchantment"
          (click)="toggleEnchantment()"></button>
        </span>
        <span class="table-checkbox-label">Any Enchantment</span>
      </div>
      @if (poe1) {
        <span class="sep"></span>
        <div class="filter-title filter-label table-checkbox-group">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.hasInfluence"
            (click)="toggleInfluenced()"></button>
          </span>
          <span class="table-checkbox-label">Influenced</span>
        </div>
        <span class="sep"></span>
        <div class="filter-title filter-label table-checkbox-group">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.zanaMemory"
            (click)="toggleZanaMemory()"></button>
          </span>
          <span class="table-checkbox-label">Memory-Influenced</span>
        </div>
        <span class="sep"></span>
        <div class="filter-title filter-label table-checkbox-group">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.blightedMap"
            (click)="toggleBlightedMap()"></button>
          </span>
          <span class="table-checkbox-label">Blighted</span>
        </div>
        <span class="sep"></span>
        <div class="filter-title filter-label table-checkbox-group">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.blightRavagedMap"
            (click)="toggleBlightRavagedMap()"></button>
          </span>
          <span class="table-checkbox-label">Blight-Ravaged</span>
        </div>
        <span class="sep"></span>
        <div class="filter-title filter-label table-checkbox-group">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.eightModMap"
            (click)="toggleEightModMap()"></button>
          </span>
          <span class="table-checkbox-label">8-Mod</span>
        </div>
      }
      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}
@if (poe1 && rule.itemClass === 'Skill Gems') {
  <div class="filter filter-padded filter-double-padded-right">
    <span class="filter-body">
      <div class="filter-title" style="width: 150px">
        <span class="filter-title-text">Transfigured Gem</span>
      </div>
      <span class="sep"></span>
      <app-select [(ngModel)]="rule.advancedConditions!.transfiguredGem" (selectedValueChange)="updateFilter()" [disabled]="!rule.displayOptions.active" style="width: 300px;">
        <app-option [value]="undefined" [text]="'None'"></app-option>
        @for (gem of transfiguredGems; track gem) {
          <app-option [value]="gem" [text]="gem"></app-option>
        }
      </app-select>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.imbuedGem"
          (click)="rule.advancedConditions!.imbuedGem = !rule.advancedConditions!.imbuedGem; updateFilter();"></button>
        </span>
        <span class="table-checkbox-label">Imbued Gem</span>
      </div>
      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}
@if (poe1 && rule.itemClass === 'Jewels') {
  <div class="filter filter-padded filter-double-padded-right">
    <span class="filter-body">
      <div class="filter-title" style="width: 150px">
        <span class="filter-title-text">Cluster Jewels</span>
      </div>
      <span class="sep"></span>
      <span class="filter-title filter-label">Passives</span>
      <span class="sep"></span>
      <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
        [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.minClusterJewelPassives!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
      <span class="sep"></span>
      <input type="number" placeholder="max" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
        [class.disabled]="!rule.displayOptions.active" [(ngModel)]="rule.advancedConditions!.maxClusterJewelPassives!" (change)="updateFilter()" style="min-width: 40px; width: 40px;">
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!rule.advancedConditions!.clusterJewelPassiveNodes" [disabled]="!rule.displayOptions.active"
            (click)="toggleClusterJewelEnchantments()"></button>
        </span>
        <span class="table-checkbox-label">Enchantments</span>
      </div>
      <span class="sep"></span>
      <app-autocomplete
        [allowNone]="true"
        [allowAll]="false"
        [disabled]="!rule.displayOptions.active || rule.advancedConditions!.clusterJewelPassiveNodes === undefined"
        [options]="clusterJewelPassiveNodes"
        [showOptions]="true"
        [selectedValues]="rule.advancedConditions!.clusterJewelPassiveNodes || []"
        (selectedValuesChange)="clusterJewelPassiveNodesChange($event)"
        style="width: 300px;">
      </app-autocomplete>
      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}
